import type { HTMLAttributes } from 'react';

import { formatMoney } from '@/shared/lib/money';
import { cn } from '@/shared/lib/utils';

export interface MoneyProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  /** Číselná hodnota částky (v domácí měně, pokud není řečeno jinak). */
  value: number;
  /** Volitelný kód měny renderovaný jako muted přípona (např. „CZK“). */
  currency?: string | null;
  /** Počet desetinných míst (default 1). */
  decimals?: number;
}

/**
 * Sdílená komponenta pro zobrazení peněžní částky: tabulární číslice, bez zalomení, oddělovač tisíců,
 * pevný počet desetinných míst (default 1) + volitelný muted kód měny. Styluje se čistě Tailwindem.
 */
export function Money({ value, currency, decimals, className, ...rest }: MoneyProps) {
  return (
    <span
      className={cn('inline-flex items-baseline gap-1 whitespace-nowrap tabular-nums', className)}
      {...rest}
    >
      {formatMoney(value, { decimals })}
      {currency ? <span className="text-phx-text-muted text-phx-xs">{currency}</span> : null}
    </span>
  );
}
